import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { NoteState } from "../../context/notes/NoteState";
import UserServices from "../../UserServices/UserServices";
import Swal from "sweetalert2";
import moment from "moment";
import MenuButton from "../MenuButton/MenuButton";
import jsPDF from "jspdf";
import "jspdf-autotable";

// â”€â”€â”€ helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€
const STATUS_OPTIONS = ["Delivered", "No Show", "Cancel", "Canceled"];
const TYPES = ["PT", "SPT", "GX", "Befit"];

const pkr = (n) =>
  Number(n || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 });

const statusBadge = (s) => {
  const map = {
    Delivered: "badge bg-success",
    "No Show": "badge bg-warning text-dark",
    Cancel: "badge bg-secondary",
    Canceled: "badge bg-secondary",
  };
  return <span className={map[s] || "badge bg-light text-dark"}>{s}</span>;
};

// â”€â”€â”€ Reusable form modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SessionModal = ({
  mode,          // "add" | "edit"
  initialData,
  trainers,
  selectedTrainer,
  clients,
  onClose,
  onSave,
  saving,
}) => {
  const today = moment().format("YYYY-MM-DD");
  const [form, setForm] = useState(
    mode === "edit"
      ? { ...initialData }
      : {
          branch_id:     initialData?.branch_id || "",
          trainer_id:    selectedTrainer?.id || "",
          client_id:     "",
          order_id:      "",
          package_id:    "",
          date:          today,
          staff_status:  "Delivered",
          client_status: "Delivered",
          type:          "PT",
          staff_note:    "",
          client_note:   "",
        }
  );

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleClientChange = (e) => {
    const orderId = e.target.value;
    const client = clients.find((c) => String(c.order_id) === orderId);
    if (client) {
      set("order_id",   String(client.order_id));
      set("client_id",  String(client.client_id));
      set("package_id", String(client.package_id));
      set("branch_id",  String(client.branch_id || form.branch_id));
    }
  };

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.55)" }}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 540 }}>
        <div className="modal-content border-0 shadow" style={{ borderRadius: 14 }}>
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold">
              <i
                className={`fa ${
                  mode === "add" ? "fa-plus-circle" : "fa-edit"
                } text-primary me-2`}
              />
              {mode === "add" ? "Add Session" : "Edit Session"}
            </h5>
            <button className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body pt-3">
            {/* Trainer (for add) */}
            {mode === "add" && (
              <div className="mb-3">
                <label className="form-label fw-semibold small">Trainer *</label>
                <select
                  className="form-select"
                  value={form.trainer_id}
                  onChange={(e) => set("trainer_id", e.target.value)}
                >
                  <option value="">-- Select Trainer --</option>
                  {trainers.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name} ({t.branch_name})
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Client / order */}
            {mode === "add" && clients.length > 0 && (
              <div className="mb-3">
                <label className="form-label fw-semibold small">Client / Package *</label>
                <select
                  className="form-select"
                  value={form.order_id}
                  onChange={handleClientChange}
                >
                  <option value="">-- Select Client --</option>
                  {clients.map((c) => (
                    <option key={c.order_id} value={c.order_id}>
                      {c.client_name} - {c.package_name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Date */}
            <div className="mb-3">
              <label className="form-label fw-semibold small">Session Date *</label>
              <input
                type="date"
                className="form-control"
                value={form.date}
                onChange={(e) => set("date", e.target.value)}
              />
            </div>

            {/* Status row */}
            <div className="row g-3 mb-3">
              <div className="col-6">
                <label className="form-label fw-semibold small">Trainer Status *</label>
                <select
                  className="form-select"
                  value={form.staff_status}
                  onChange={(e) => set("staff_status", e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s}>{s}</option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <label className="form-label fw-semibold small">Client Status *</label>
                <select
                  className="form-select"
                  value={form.client_status}
                  onChange={(e) => set("client_status", e.target.value)}
                >
                  {STATUS_OPTIONS.map((s) => (
                    <option key={s}>{s}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Type + Validate */}
            <div className="row g-3 mb-3">
              <div className="col-6">
                <label className="form-label fw-semibold small">Session Type</label>
                <select
                  className="form-select"
                  value={form.type}
                  onChange={(e) => set("type", e.target.value)}
                >
                  {TYPES.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
              </div>
              {mode === "edit" && (
                <div className="col-6">
                  <label className="form-label fw-semibold small">Validated</label>
                  <select
                    className="form-select"
                    value={String(form.validate_status)}
                    onChange={(e) => set("validate_status", e.target.value)}
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              )}
            </div>

            {/* Notes */}
            <div className="row g-3">
              <div className="col-6">
                <label className="form-label small text-muted">Trainer Note</label>
                <textarea
                  className="form-control form-control-sm"
                  rows={2}
                  value={form.staff_note || ""}
                  onChange={(e) => set("staff_note", e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label small text-muted">Client Note</label>
                <textarea
                  className="form-control form-control-sm"
                  rows={2}
                  value={form.client_note || ""}
                  onChange={(e) => set("client_note", e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button className="btn btn-light" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary px-4"
              disabled={saving}
              onClick={() => onSave(form)}
            >
              {saving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Saving...
                </>
              ) : (
                <>
                  <i className="bi bi-save me-2" />
                  Save
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// â”€â”€â”€ Bulk session modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const BulkModal = ({ trainers, onClose, onSave, saving }) => {
  const [trainerId, setTrainerId]       = useState("");
  const [clients, setClients]           = useState([]);
  const [loadingC, setLoadingC]         = useState(false);
  const [orderId, setOrderId]           = useState("");
  const [clientId, setClientId]         = useState("");
  const [packageId, setPackageId]       = useState("");
  const [branchId, setBranchId]         = useState("");
  const [sessionCount, setSessionCount] = useState("");
  const [date, setDate]                 = useState(moment().format("YYYY-MM-DD"));
  const [staffStatus, setStaffStatus]   = useState("Delivered");
  const [clientStatus, setClientStatus] = useState("Delivered");
  const [type, setType]                 = useState("PT");

  const loadClients = async (tid) => {
    if (!tid) return;
    setLoadingC(true);
    try {
      const res = await UserServices.hrPortalTrainerClients(tid, null, false);
      setClients(res.data?.data || []);
    } catch {
      setClients([]);
    } finally {
      setLoadingC(false);
    }
  };

  const handleClientChange = (e) => {
    const oid = e.target.value;
    const c = clients.find((x) => String(x.order_id) === oid);
    if (c) {
      setOrderId(oid);
      setClientId(String(c.client_id));
      setPackageId(String(c.package_id));
      setBranchId(String(c.branch_id || ""));
    }
  };

  const selectedClient = clients.find((x) => String(x.order_id) === orderId);

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.55)" }}>
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 520 }}>
        <div className="modal-content border-0 shadow" style={{ borderRadius: 14 }}>
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold">
              <i className="bi bi-layers text-primary me-2" />
              Bulk Add Sessions
            </h5>
            <button className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body pt-3">

            {/* Trainer */}
            <div className="mb-3">
              <label className="form-label fw-semibold small">Trainer *</label>
              <select className="form-select" value={trainerId} onChange={(e) => {
                setTrainerId(e.target.value); setOrderId(""); setClients([]);
                loadClients(e.target.value);
              }}>
                <option value="">-- Select Trainer --</option>
                {trainers.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>

            {/* Client */}
            <div className="mb-3">
              <label className="form-label fw-semibold small">Client / Package *</label>
              {loadingC ? <div className="spinner-border spinner-border-sm text-primary" /> : (
                <select className="form-select" value={orderId} onChange={handleClientChange} disabled={!trainerId}>
                  <option value="">-- Select Client --</option>
                  {clients.map((c) => (
                    <option key={c.order_id} value={c.order_id}>
                      {c.client_name} - {c.package_name} ({Math.max(0, c.sessions_remaining)} remaining)
                    </option>
                  ))}
                </select>
              )}
            </div>

            {/* Session count + date row */}
            <div className="row g-3 mb-3">
              <div className="col-5">
                <label className="form-label fw-semibold small">Number of Sessions *</label>
                <input type="number" className="form-control" min={1} max={100} value={sessionCount}
                  onChange={(e) => setSessionCount(e.target.value)} />
                {selectedClient && (
                  <small className="text-muted">{Math.max(0, selectedClient.sessions_remaining)} remaining</small>
                )}
              </div>
              <div className="col-7">
                <label className="form-label fw-semibold small">Session Date *</label>
                <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
              </div>
            </div>

            {/* Summary box */}
            {orderId && parseInt(sessionCount) > 0 && (
              <div className="alert alert-info py-2 mb-3" style={{ fontSize: 12 }}>
                <i className="bi bi-info-circle me-1" />
                <strong>{parseInt(sessionCount)} record{parseInt(sessionCount) > 1 ? "s" : ""}</strong> will be inserted for{" "}
                <strong>{selectedClient?.client_name}</strong> on{" "}
                <strong>{moment(date).format("DD MMM YYYY")}</strong>.
                <br />
                <small className="text-muted">Each record is saved with staff_note: "Bulk attendance - {parseInt(sessionCount)} sessions by HR"</small>
              </div>
            )}

            {/* Status row */}
            <div className="row g-3 mb-1">
              <div className="col-4">
                <label className="form-label fw-semibold small">Trainer Status</label>
                <select className="form-select" value={staffStatus} onChange={(e) => setStaffStatus(e.target.value)}>
                  {STATUS_OPTIONS.slice(0, 3).map((s) => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div className="col-4">
                <label className="form-label fw-semibold small">Client Status</label>
                <select className="form-select" value={clientStatus} onChange={(e) => setClientStatus(e.target.value)}>
                  {STATUS_OPTIONS.slice(0, 3).map((s) => <option key={s}>{s}</option>)}
                </select>
              </div>
              <div className="col-4">
                <label className="form-label fw-semibold small">Type</label>
                <select className="form-select" value={type} onChange={(e) => setType(e.target.value)}>
                  {TYPES.map((t) => <option key={t}>{t}</option>)}
                </select>
              </div>
            </div>
          </div>

          <div className="modal-footer border-0 pt-0">
            <button className="btn btn-light" onClick={onClose}>Cancel</button>
            <button className="btn btn-success px-4"
              disabled={saving || !orderId || !date || !(parseInt(sessionCount) >= 1)}
              onClick={() => onSave({
                branch_id: branchId, trainer_id: trainerId, client_id: clientId,
                order_id: orderId, package_id: packageId,
                session_count: parseInt(sessionCount), date,
                staff_status: staffStatus, client_status: clientStatus, type,
              })}>
              {saving ? (
                <><span className="spinner-border spinner-border-sm me-2" />Adding...</>
              ) : (
                <><i className="bi bi-layers me-2" />Add {parseInt(sessionCount) || 0} Session{parseInt(sessionCount) > 1 ? "s" : ""}</>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};



//  Main Component

const HRAttendancePortal = () => {
  const { state } = useContext(NoteState);
  const { branch_id, role, UId } = state;

  const isHR      = role === "1" || role === "11" || role === "12";
  const isTrainer = role === "9";

  // â”€â”€ Payroll period â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const defaultStart = moment()
    .subtract(1, "month")
    .startOf("month")
    .date(26)
    .format("YYYY-MM-DD");
  const defaultEnd = moment().startOf("month").date(25).format("YYYY-MM-DD");

  const [periodStart, setPeriodStart] = useState(defaultStart);
  const [periodEnd, setPeriodEnd]     = useState(defaultEnd);

  // â”€â”€ Tabs â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [activeTab, setActiveTab] = useState(isTrainer ? "report" : "sessions"); // sessions | commissions | report

  // â”€â”€ Sessions state 
  const [sessions, setSessions]         = useState([]);
  const [sessionLoading, setSessionLoading] = useState(false);
  const [sessionTotal, setSessionTotal] = useState(0);
  const [sessionPage, setSessionPage]   = useState(1);
  const [sessionFilters, setSessionFilters] = useState({
    trainer_id:    "",
    client_id:     "",
    staff_status:  "",
    client_status: "",
    start_date:    defaultStart,
    end_date:      defaultEnd,
    limit:         25,
  });

  // â”€â”€ Commissions state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

  // -- Session Report state --
  const [report, setReport]               = useState([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportTotal, setReportTotal]     = useState(0);
  const [reportPage, setReportPage]       = useState(1);
  const [reportFilters, setReportFilters] = useState({
    trainer_id:    isTrainer ? UId : "",
    client_id:     "",
    staff_status:  "",
    client_status: "",
    start_date:    defaultStart,
    end_date:      defaultEnd,
    limit:         25,
  });
  const [reportClients, setReportClients]               = useState([]);
  const [reportClientsLoading, setReportClientsLoading] = useState(false);
  const [exportLoading, setExportLoading]               = useState(false);

  const [commissions, setCommissions]     = useState([]);
  const [commissionLoading, setCommissionLoading] = useState(false);
  const [expandedTrainer, setExpandedTrainer] = useState(null);
  const [commTrainerId, setCommTrainerId] = useState("");
  const [commFrom, setCommFrom]           = useState(defaultStart);
  const [commTo, setCommTo]               = useState(defaultEnd);

  // â”€â”€ Trainers / clients lists â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [trainers, setTrainers]   = useState([]);
  const [hrClients, setHrClients] = useState([]);

  // â”€â”€ Modal state â”€â”€â”€
  const [showAddModal, setShowAddModal]   = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [modalSaving, setModalSaving]     = useState(false);

  // â”€â”€ Selected trainer for add/client fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [addTrainer, setAddTrainer] = useState(null);

  // â”€â”€ Load trainers once â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    UserServices.hrPortalAllTrainers(branch_id)
      .then((r) => setTrainers((r.data?.data || []).filter((t) => ![10317, 10321].includes(Number(t.id)))))
      .catch(() => setTrainers([]));
  }, [branch_id]);

  // â”€â”€ Fetch sessions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const fetchSessions = useCallback(async () => {
    setSessionLoading(true);
    try {
      const res = await UserServices.hrPortalGetSessions({
        branch_id,
        page: sessionPage,
        ...sessionFilters,
      });
      setSessions(res.data?.data?.data || []);
      setSessionTotal(res.data?.totalRecord || 0);
    } catch {
      setSessions([]);
      setSessionTotal(0);
    } finally {
      setSessionLoading(false);
    }
  }, [branch_id, sessionPage, sessionFilters]);

  // â”€â”€ Fetch commissions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const fetchCommissions = useCallback(async () => {
    setCommissionLoading(true);
    try {
      const res = await UserServices.hrPortalAllCommissions({
        branch_id,
        trainer_id: commTrainerId || undefined,
        start_date: commFrom,
        end_date:   commTo,
        limit:      100,
      });
      setCommissions((res.data?.data || []).filter((t) => ![10317, 10321].includes(Number(t.id))));
    } catch {
      setCommissions([]);
    } finally {
      setCommissionLoading(false);
    }
  }, [branch_id, commTrainerId, commFrom, commTo]);

  // -- Fetch Session Report --
  const fetchReport = useCallback(async () => {
    setReportLoading(true);
    try {
      const res = await UserServices.hrPortalGetSessions({
        branch_id,
        page: reportPage,
        ...reportFilters,
      });
      setReport(res.data?.data?.data || []);
      setReportTotal(res.data?.totalRecord || 0);
    } catch {
      setReport([]);
      setReportTotal(0);
    } finally {
      setReportLoading(false);
    }
  }, [branch_id, reportPage, reportFilters]);

  const fetchAllAndExport = async (format) => {
    setExportLoading(format);
    try {
      const res = await UserServices.hrPortalGetSessions({
        branch_id,
        page: 1,
        limit: 100000,
        trainer_id:    reportFilters.trainer_id,
        client_id:     reportFilters.client_id,
        staff_status:  reportFilters.staff_status,
        client_status: reportFilters.client_status,
        start_date:    reportFilters.start_date,
        end_date:      reportFilters.end_date,
      });
      const all = res.data?.data?.data || [];
      const total = res.data?.totalRecord || all.length;
      const trainerName = reportFilters.trainer_id
        ? (trainers.find((t) => String(t.id) === String(reportFilters.trainer_id))?.name || "")
        : "All Trainers";
      const dateRange = reportFilters.start_date && reportFilters.end_date
        ? `${moment(reportFilters.start_date).format("DD MMM YYYY")} \u2013 ${moment(reportFilters.end_date).format("DD MMM YYYY")}`
        : "All Dates";

      if (format === "pdf") {
        const doc = new jsPDF("l", "mm", "a4");
        doc.setFontSize(14);
        doc.text("Session Report", 14, 14);
        doc.setFontSize(9);
        doc.text(`Trainer: ${trainerName}   |   Period: ${dateRange}   |   Records: ${total}`, 14, 21);
        doc.autoTable({
          startY: 26,
          styles: { fontSize: 7, cellPadding: 2 },
          headStyles: { fillColor: [41, 128, 185], textColor: 255 },
          alternateRowStyles: { fillColor: [245, 245, 245] },
          head: [["#", "Date", "Trainer", "Client", "Package", "Pkg Start", "Pkg End", "Trainer Status", "Client Status", "Validated"]],
          body: all.map((s, idx) => [
            idx + 1,
            moment(s.date).format("DD MMM YYYY"),
            s.trainer_name,
            s.client_name,
            `${s.package_name} (${s.package_type})`,
            s.package_start_date ? moment(s.package_start_date).format("DD MMM YY") : "",
            s.package_end_date   ? moment(s.package_end_date).format("DD MMM YY")   : "",
            s.staff_status,
            s.client_status,
            String(s.validate_status) === "1" ? "Yes" : "No",
          ]),
        });
        doc.save(`Session_Report_${moment().format("YYYYMMDD_HHmm")}.pdf`);
      } else {
        const headers = ["#", "Date", "Trainer", "Client", "Package", "Package Type", "Pkg Start", "Pkg End", "Trainer Status", "Client Status", "Validated"];
        const rows = all.map((s, idx) => [
          idx + 1,
          moment(s.date).format("DD MMM YYYY"),
          s.trainer_name,
          s.client_name,
          s.package_name,
          s.package_type,
          s.package_start_date ? moment(s.package_start_date).format("DD MMM YYYY") : "",
          s.package_end_date   ? moment(s.package_end_date).format("DD MMM YYYY")   : "",
          s.staff_status,
          s.client_status,
          String(s.validate_status) === "1" ? "Yes" : "No",
        ]);
        const csv = [headers, ...rows]
          .map((r) => r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(","))
          .join("\n");
        const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Session_Report_${moment().format("YYYYMMDD_HHmm")}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch {
      Swal.fire({ icon: "error", title: "Export failed", text: "Could not fetch data for export." });
    } finally {
      setExportLoading(false);
    }
  };

  // -- Load clients for the selected trainer in report tab --
  const loadReportClients = useCallback(async (trainerId) => {
    if (!trainerId) { setReportClients([]); return; }
    setReportClientsLoading(true);
    try {
      const res = await UserServices.hrPortalTrainerClients(trainerId, branch_id, true);
      setReportClients(res.data?.data || []);
    } catch {
      setReportClients([]);
    } finally {
      setReportClientsLoading(false);
    }
  }, [branch_id]);

  useEffect(() => {
    loadReportClients(reportFilters.trainer_id);
  }, [reportFilters.trainer_id, loadReportClients]);

  useEffect(() => { fetchSessions(); }, [fetchSessions]);
  useEffect(() => {
    if (activeTab === "commissions") fetchCommissions();
  }, [activeTab, fetchCommissions]);
  useEffect(() => {
    if (activeTab === "report") fetchReport();
  }, [activeTab, fetchReport]);

  // â”€â”€ Load clients when trainer changes in add modal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const loadClientsForTrainer = async (tid) => {
    if (!tid) { setHrClients([]); return; }
    try {
      const res = await UserServices.hrPortalTrainerClients(tid, branch_id, true);
      setHrClients(res.data?.data || []);
    } catch {
      setHrClients([]);
    }
  };

  // â”€â”€ Add session â”€â”€â”€
  const handleAddSession = async (form) => {
    if (!form.trainer_id || !form.order_id || !form.date) {
      Swal.fire({ icon: "warning", title: "Missing fields", text: "Trainer, client, and date are required." });
      return;
    }
    setModalSaving(true);
    try {
      await UserServices.hrPortalAddSession(form);
      Swal.fire({ icon: "success", title: "Session Added", timer: 1800, showConfirmButton: false });
      setShowAddModal(false);
      fetchSessions();
    } catch (err) {
      const msg = err?.response?.data?.message;
      Swal.fire({ icon: "error", title: "Error", text: typeof msg === "string" ? msg : JSON.stringify(msg) });
    } finally {
      setModalSaving(false);
    }
  };

  // â”€â”€ Edit session â”€â”€
  const handleEditSession = async (form) => {
    setModalSaving(true);
    try {
      await UserServices.hrPortalUpdateSession(selectedSession.id, form);
      Swal.fire({ icon: "success", title: "Session Updated", timer: 1800, showConfirmButton: false });
      setShowEditModal(false);
      fetchSessions();
    } catch (err) {
      const msg = err?.response?.data?.message;
      Swal.fire({ icon: "error", title: "Error", text: typeof msg === "string" ? msg : JSON.stringify(msg) });
    } finally {
      setModalSaving(false);
    }
  };

  // â”€â”€ Delete session 
  const handleDelete = (id) => {
    Swal.fire({
      title: "Delete this session?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete",
    }).then(async (r) => {
      if (!r.isConfirmed) return;
      try {
        await UserServices.hrPortalDeleteSession(id);
        Swal.fire({ icon: "success", title: "Deleted", timer: 1500, showConfirmButton: false });
        fetchSessions();
      } catch (err) {
        Swal.fire({ icon: "error", title: "Error", text: "Failed to delete session." });
      }
    });
  };

  // â”€â”€ Bulk sessions â”€
  const handleBulkAdd = async (form) => {
    setModalSaving(true);
    try {
      const res = await UserServices.hrPortalBulkAddSessions(form);
      const { inserted } = res.data;
      Swal.fire({
        icon: "success",
        title: "Bulk Add Complete",
        html: `<b>${inserted}</b> session record${inserted !== 1 ? "s" : ""} added successfully.`,
        timer: 2500,
        showConfirmButton: false,
      });
      setShowBulkModal(false);
      fetchSessions();
    } catch (err) {
      const msg = err?.response?.data?.message;
      Swal.fire({ icon: "error", title: "Error", text: typeof msg === "string" ? msg : JSON.stringify(msg) });
    } finally {
      setModalSaving(false);
    }
  };

  const setFilter = (k, v) =>
    setSessionFilters((f) => ({ ...f, [k]: v }));
  const setReportFilter = (k, v) =>
    setReportFilters((f) => ({ ...f, [k]: v }));

  const totalPages = Math.ceil(sessionTotal / sessionFilters.limit) || 1;
  const reportTotalPages = Math.ceil(reportTotal / reportFilters.limit) || 1;

  return (
    <div className="mt-1 main-inner-pd">
      <div className="site-main-design">
        <MenuButton />

        {/* â”€â”€ Page header â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <div className="card shadow-sm border-0 mb-3" style={{ borderRadius: 14 }}>
          <div className="card-body p-3">
            <h4 className="fw-bold mb-0 text-primary">
              <i className="bi bi-shield-check me-2" />
              HR: Session & Commission Portal
            </h4>
            <small className="text-muted">
              Full control &middot; Add, edit, delete sessions &middot; View all commissions
            </small>
          </div>
        </div>

        {/* â”€â”€ Tabs â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <ul className="nav nav-tabs mb-3">
          {[
            ...(isHR ? [
              { key: "sessions",    label: "Sessions",    icon: "fa-th-list" },
              { key: "commissions", label: "Commissions", icon: "fa-coins" },
            ] : []),
            { key: "report", label: "Session Report", icon: "fa-chart-bar" },
          ].map((t) => (
            <li className="nav-item" key={t.key}>
              <button
                className={`nav-link ${activeTab === t.key ? "active fw-semibold" : ""}`}
                onClick={() => setActiveTab(t.key)}
              >
                <i className={`fa ${t.icon} me-1`} />
                {t.label}
              </button>
            </li>
          ))}
        </ul>

        {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
            TAB: Sessions
        â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
        {activeTab === "sessions" && (
          <>
            {/* Filter bar */}
            <div className="card border-0 shadow-sm mb-3">
              <div className="card-body p-3">
                <div className="row g-2 align-items-end">
                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-semibold mb-1">Trainer</label>
                    <select
                      className="form-select form-select-sm"
                      value={sessionFilters.trainer_id}
                      onChange={(e) => setFilter("trainer_id", e.target.value)}
                    >
                      <option value="">All Trainers</option>
                      {trainers.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">From</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={sessionFilters.start_date}
                      onChange={(e) => { setFilter("start_date", e.target.value); setSessionPage(1); }}
                    />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">To</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={sessionFilters.end_date}
                      onChange={(e) => { setFilter("end_date", e.target.value); setSessionPage(1); }}
                    />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">Trainer Status</label>
                    <select
                      className="form-select form-select-sm"
                      value={sessionFilters.staff_status}
                      onChange={(e) => setFilter("staff_status", e.target.value)}
                    >
                      <option value="">All</option>
                      {STATUS_OPTIONS.map((s) => (
                        <option key={s}>{s}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">Client Status</label>
                    <select
                      className="form-select form-select-sm"
                      value={sessionFilters.client_status}
                      onChange={(e) => setFilter("client_status", e.target.value)}
                    >
                      <option value="">All</option>
                      {STATUS_OPTIONS.map((s) => (
                        <option key={s}>{s}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">Per Page</label>
                    <select
                      className="form-select form-select-sm"
                      value={sessionFilters.limit}
                      onChange={(e) => setFilter("limit", Number(e.target.value))}
                    >
                      {[10, 25, 50, 100].map((n) => (
                        <option key={n}>{n}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-3 d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm flex-fill"
                      onClick={() => { setSessionPage(1); fetchSessions(); }}
                    >
                      <i className="bi bi-search me-1" />
                      Filter
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => {
                        setSessionFilters({
                          trainer_id: "", client_id: "",
                          staff_status: "", client_status: "",
                          start_date: defaultStart, end_date: defaultEnd, limit: 25,
                        });
                        setSessionPage(1);
                      }}
                    >
                      <i className="bi bi-x-lg" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div className="d-flex gap-2 mb-3 flex-wrap">
              <button
                className="btn btn-success btn-sm px-3"
                onClick={() => {
                  setHrClients([]);
                  setShowAddModal(true);
                }}
              >
                <i className="bi bi-plus-lg me-1" />
                Add Session
              </button>
              <button
                className="btn btn-info btn-sm text-white px-3"
                onClick={() => setShowBulkModal(true)}
              >
                <i className="bi bi-layers me-1" />
                Bulk Add
              </button>
              <span className="text-muted small align-self-center ms-2">
                {sessionTotal} total records
              </span>
            </div>

            {/* Sessions table */}
            <div className="card border-0 shadow-sm">
              {sessionLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" />
                  <p className="mt-2 text-muted">Loading sessions...</p>
                </div>
              ) : sessions.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="bi bi-list-ul fa-3x mb-3 d-block" />
                  <p>No sessions found. Adjust filters or add a session.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover align-middle small mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Date</th>
                          <th>Trainer</th>
                          <th>Client</th>
                          <th>Package</th>
                          <th>Trainer Status</th>
                          <th>Client Status</th>
                          <th className="text-center">Type</th>
                          <th className="text-center">Validated</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sessions.map((s, idx) => (
                          <tr key={s.id}>
                            <td className="text-muted">
                              {(sessionPage - 1) * sessionFilters.limit + idx + 1}
                            </td>
                            <td>
                              <span className="fw-semibold">
                                {moment(s.date).format("DD MMM YYYY")}
                              </span>
                              <br />
                              <small className="text-muted">{s.day}</small>
                            </td>
                            <td className="fw-semibold">{s.trainer_name}</td>
                            <td>{s.client_name}</td>
                            <td className="text-muted">
                              <span className="badge bg-outline-secondary border me-1">
                                {s.package_type}
                              </span>
                              {s.package_name}
                            </td>
                            <td>{statusBadge(s.staff_status)}</td>
                            <td>{statusBadge(s.client_status)}</td>
                            <td className="text-center">
                              <span className="badge bg-primary">{s.type}</span>
                            </td>
                            <td className="text-center">
                              {String(s.validate_status) === "1" ? (
                                <i className="bi bi-check-circle-fill text-success" />
                              ) : (
                                <i className="bi bi-hourglass-split text-warning" />
                              )}
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-sm btn-outline-primary me-1"
                                title="Edit"
                                onClick={() => {
                                  setSelectedSession(s);
                                  setShowEditModal(true);
                                }}
                              >
                                <i className="bi bi-pencil-square" />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                title="Delete"
                                onClick={() => handleDelete(s.id)}
                              >
                                <i className="bi bi-trash" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="card-footer d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                      Page {sessionPage} of {totalPages} &middot; {sessionTotal} records
                    </small>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={sessionPage <= 1}
                        onClick={() => setSessionPage((p) => p - 1)}
                      >
                        <i className="bi bi-chevron-left" /> Prev
                      </button>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={sessionPage >= totalPages}
                        onClick={() => setSessionPage((p) => p + 1)}
                      >
                        Next <i className="bi bi-chevron-right" />
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}

        {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
            TAB: Commissions
        â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
        {activeTab === "commissions" && (
          <>
            {/* Commission Filters */}
            <div className="card border-0 shadow-sm mb-3">
              <div className="card-body py-2">
                <div className="row g-2 align-items-end">
                  <div className="col-12 col-md-3">
                    <label className="form-label fw-semibold small mb-1">Trainer</label>
                    <select
                      className="form-select form-select-sm"
                      value={commTrainerId}
                      onChange={(e) => setCommTrainerId(e.target.value)}
                    >
                      <option value="">All Trainers</option>
                      {trainers.map((t) => (
                        <option key={t.id} value={t.id}>{t.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="form-label fw-semibold small mb-1">From</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={commFrom}
                      onChange={(e) => setCommFrom(e.target.value)}
                    />
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="form-label fw-semibold small mb-1">To</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={commTo}
                      onChange={(e) => setCommTo(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-md-3 d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm flex-grow-1"
                      onClick={fetchCommissions}
                      disabled={commissionLoading}
                    >
                      <i className="bi bi-calculator me-1" />
                      Calculate
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      title="Reset filters"
                      onClick={() => {
                        setCommTrainerId("");
                        setCommFrom(defaultStart);
                        setCommTo(defaultEnd);
                      }}
                    >
                      <i className="bi bi-x-lg" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {commissionLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" />
                <p className="mt-2 text-muted">Calculating all commissions...</p>
              </div>
            ) : commissions.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <i className="bi bi-coin fa-3x mb-3 d-block" />
                <p>No commission data for selected period.</p>
              </div>
            ) : (
              <>
                {/* Summary row */}
                <div className="row mb-3">
                  <div className="col-12 col-md-4 mb-2">
                    <div className="card border-0 shadow-sm text-center p-3">
                      <p className="text-muted small mb-1">Total Trainers</p>
                      <h3 className="fw-bold text-primary mb-0">{commissions.length}</h3>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 mb-2">
                    <div className="card border-0 shadow-sm text-center p-3">
                      <p className="text-muted small mb-1">Total Gross Commission</p>
                      <h3 className="fw-bold text-success mb-0">
                        PKR{" "}
                        {pkr(
                          commissions.reduce((s, t) => {
                            const nsB = (t.commission?.details || []).reduce((sum, d) => {
                              const fin = d.is_package_finalized && (d.remaining_contract_sessions ?? 0) > 0;
                              return sum + (fin ? Math.ceil((d.commissionPerSession ?? 0) * (d.remaining_contract_sessions ?? 0)) : 0);
                            }, 0);
                            return s + (t.commission?.gross_commission || 0) + nsB;
                          }, 0)
                        )}
                      </h3>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 mb-2">
                    <div className="card border-0 shadow-sm text-center p-3">
                      <p className="text-muted small mb-1">Total Outstanding</p>
                      <h3 className="fw-bold text-danger mb-0">
                        PKR{" "}
                        {pkr(
                          commissions.reduce((s, t) => {
                            const nsB = (t.commission?.details || []).reduce((sum, d) => {
                              const fin = d.is_package_finalized && (d.remaining_contract_sessions ?? 0) > 0;
                              return sum + (fin ? Math.ceil((d.commissionPerSession ?? 0) * (d.remaining_contract_sessions ?? 0)) : 0);
                            }, 0);
                            return s + (t.commission?.outstanding_commission || 0) + nsB;
                          }, 0)
                        )}
                      </h3>
                    </div>
                  </div>
                </div>

                {/* Per-trainer commission cards */}
                <div className="card border-0 shadow-sm">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle small mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Trainer</th>
                          <th>Branch</th>
                          <th className="text-center">Commission %</th>
                          <th className="text-center">Sessions</th>
                          <th className="text-end">Gross</th>
                          <th className="text-end">Paid</th>
                          <th className="text-end">Outstanding</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Detail</th>
                        </tr>
                      </thead>
                      <tbody>
                        {commissions.map((t) => {
                          const c = t.commission || {};
                          const isExpanded = expandedTrainer === t.id;
                          const nsBonus = (c.details || []).reduce((sum, d) => {
                            const fin = d.is_package_finalized && (d.remaining_contract_sessions ?? 0) > 0;
                            return sum + (fin ? Math.ceil((d.commissionPerSession ?? 0) * (d.remaining_contract_sessions ?? 0)) : 0);
                          }, 0);
                          const remainingNSCount = (c.details || []).reduce((sum, d) => {
                            const fin = d.is_package_finalized && (d.remaining_contract_sessions ?? 0) > 0;
                            return sum + (fin ? (d.remaining_contract_sessions ?? 0) : 0);
                          }, 0);
                          const adjustedGross = (c.gross_commission || 0) + nsBonus;
                          const adjustedOutstanding = (c.outstanding_commission || 0) + nsBonus;
                          return (
                            <React.Fragment key={t.id}>
                              <tr>
                                <td className="fw-bold">{t.name}</td>
                                <td className="text-muted">{t.branch}</td>
                                <td className="text-center">{c.commission_per}%</td>
                                <td className="text-center">
                                  <span className="badge bg-success rounded-pill me-1">
                                    {c.total_delivered_sessions} done
                                  </span>
                                  <span className="badge bg-warning text-dark rounded-pill me-1">
                                    {c.total_client_no_show_sessions} NS
                                  </span>
                                  {remainingNSCount > 0 && (
                                    <span className="badge rounded-pill" style={{ background: "#e65100", color: "#fff" }}>
                                      {remainingNSCount} Remaining NS
                                    </span>
                                  )}
                                </td>
                                <td className="text-end fw-bold" style={{ color: nsBonus > 0 ? "#e65100" : "#198754" }}>
                                  PKR {pkr(adjustedGross)}
                                  {nsBonus > 0 && (
                                    <><br /><small style={{ fontSize: 10, color: "#adb5bd" }}>+PKR {pkr(nsBonus)} NS</small></>
                                  )}
                                </td>
                                <td className="text-end text-primary">
                                  PKR {pkr(c.paid_commission)}
                                </td>
                                <td className="text-end fw-bold" style={{ color: "#dc3545" }}>
                                  PKR {pkr(adjustedOutstanding)}
                                  {nsBonus > 0 && (
                                    <><br /><small style={{ fontSize: 10, color: "#adb5bd" }}>+PKR {pkr(nsBonus)} NS</small></>
                                  )}
                                </td>
                                <td className="text-center">
                                  {c.payout_status === "paid" ? (
                                    <span className="badge bg-success">Paid</span>
                                  ) : c.payout_status === "partial" ? (
                                    <span className="badge bg-warning text-dark">Partial</span>
                                  ) : (
                                    <span className="badge bg-danger">Unpaid</span>
                                  )}
                                </td>
                                <td className="text-center">
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() =>
                                      setExpandedTrainer(isExpanded ? null : t.id)
                                    }
                                  >
                                    <i
                                      className={`bi bi-chevron-${isExpanded ? "up" : "down"}`}
                                    />
                                  </button>
                                </td>
                              </tr>
                              {/* Expanded details */}
                              {isExpanded && c.details && c.details.length > 0 && (
                                <tr>
                                  <td colSpan={9} className="p-0">
                                    <div className="bg-light p-3">
                                      <table className="table table-sm table-bordered small mb-0" style={{ borderColor: "#dee2e6" }}>
                                        <thead className="table-secondary">
                                          <tr>
                                            <th style={{ borderRight: "2px solid #adb5bd" }}>Client</th>
                                            <th className="text-center" style={{ borderRight: "2px solid #adb5bd" }}>Total Sess.</th>
                                            <th className="text-end" style={{ borderRight: "2px solid #adb5bd" }}>Price (Ex. GST)</th>
                                            <th className="text-center">Start Date</th>
                                            <th className="text-center">End Date</th>
                                            <th className="text-center" style={{ borderRight: "2px solid #adb5bd" }}>Status</th>
                                            <th className="text-center">Already Conducted</th>
                                            <th className="text-center">In Period</th>
                                            <th className="text-center">Remaining</th>
                                            <th className="text-center" style={{ color: "#e65100", borderRight: "2px solid #adb5bd" }}>Remaining (NS)</th>
                                            <th className="text-center">No Shows</th>
                                            <th className="text-center" style={{ borderRight: "2px solid #adb5bd" }}>Payable</th>
                                            <th className="text-end">Commission</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {c.details.map((d, i) => {
                                            const hasFinalizedRemaining = d.is_package_finalized && (d.remaining_contract_sessions ?? 0) > 0;
                                            const remainingNS = hasFinalizedRemaining ? (d.remaining_contract_sessions ?? 0) : 0;
                                            const adjustedPayable = (d.payable_sessions ?? 0) + remainingNS;
                                            const additionalComm = hasFinalizedRemaining ? Math.ceil((d.commissionPerSession ?? 0) * remainingNS) : 0;
                                            const adjustedComm = (d.commission ?? 0) + additionalComm;
                                            return (
                                              <tr
                                                key={i}
                                                style={hasFinalizedRemaining ? { background: "#fff3e0", borderLeft: "4px solid #e65100" } : {}}
                                              >
                                              <td className="fw-semibold" style={{ borderRight: "2px solid #adb5bd" }}>{d.client_name}</td>
                                              <td className="text-center" style={{ borderRight: "2px solid #adb5bd" }}>{d.total_sessions_in_package}</td>
                                              <td className="text-end text-dark fw-semibold" style={{ borderRight: "2px solid #adb5bd" }}>
                                                PKR {pkr(d.net ?? 0)}
                                              </td>
                                              <td className="text-center text-muted">
                                                {d.date_of_joining ? moment(d.date_of_joining).format("DD-MMM-YY") : "—"}
                                              </td>
                                              <td className="text-center text-muted">
                                                {d.date_of_expiry ? moment(d.date_of_expiry).format("DD-MMM-YY") : "—"}
                                              </td>
                                              <td className="text-center" style={{ borderRight: "2px solid #adb5bd" }}>
                                                {d.is_package_finalized ? (
                                                  <span className="badge bg-success">Completed</span>
                                                ) : (
                                                  <span className="badge bg-primary">In Progress</span>
                                                )}
                                              </td>
                                              <td className="text-center text-secondary">
                                                {Math.max(0, (d.all_time_sessions_taken ?? 0) - (d.delivered_sessions ?? 0))}
                                              </td>
                                              <td className="text-center text-success">{d.delivered_sessions}</td>
                                              <td className="text-center text-danger fw-semibold">
                                                {d.remaining_contract_sessions ?? 0}
                                              </td>
                                              <td className="text-center fw-bold" style={{ color: remainingNS > 0 ? "#e65100" : "#adb5bd", whiteSpace: "nowrap", borderRight: "2px solid #adb5bd" }}>
                                                {remainingNS > 0 ? `${remainingNS} (NS)` : "—"}
                                              </td>
                                              <td className="text-center text-warning">{d.client_no_show_count}</td>
                                              <td className="text-center fw-bold" style={{ color: hasFinalizedRemaining ? "#e65100" : "#0d6efd", whiteSpace: "nowrap", borderRight: "2px solid #adb5bd" }}>
                                                {hasFinalizedRemaining
                                                  ? <>{d.payable_sessions} + {remainingNS} = <span style={{ color: "#e65100" }}>{adjustedPayable}</span></>
                                                  : adjustedPayable}
                                              </td>
                                              <td className="text-end fw-bold" style={{ whiteSpace: "nowrap" }}>
                                                {hasFinalizedRemaining ? (
                                                  <>
                                                    <span style={{ color: "#198754" }}>{pkr(d.commission ?? 0)}</span>
                                                    <span style={{ color: "#555" }}> + </span>
                                                    <span style={{ color: "#e65100" }}>{pkr(additionalComm)}</span>
                                                    <span style={{ color: "#555" }}> = </span>
                                                    <span style={{ color: "#e65100" }}>PKR {pkr(adjustedComm)}</span>
                                                  </>
                                                ) : (
                                                  <span style={{ color: "#198754" }}>PKR {pkr(adjustedComm)}</span>
                                                )}
                                              </td>
                                            </tr>
                                            );
                                          })}
                                        </tbody>
                                        <tfoot>
                                          {(() => {
                                            const adjustedTotal = c.details.reduce((sum, d) => {
                                              const finalized = d.is_package_finalized && (d.remaining_contract_sessions ?? 0) > 0;
                                              const addComm = finalized ? Math.ceil((d.commissionPerSession ?? 0) * (d.remaining_contract_sessions ?? 0)) : 0;
                                              return sum + (d.commission ?? 0) + addComm;
                                            }, 0);
                                            return (
                                              <tr className="fw-bold">
                                                <td colSpan={12} className="text-end">Total</td>
                                                <td className="text-end text-success">
                                                  PKR {pkr(adjustedTotal)}
                                                </td>
                                              </tr>
                                            );
                                          })()}
                                        </tfoot>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
            Modals
        â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}

        {/* SESSION REPORT TAB */}
        {activeTab === "report" && (
          <>
            {/* Top action bar — export buttons */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="fw-semibold text-secondary small">
                {reportTotal} total records
              </span>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-outline-danger btn-sm"
                  disabled={exportLoading === "pdf"}
                  onClick={() => fetchAllAndExport("pdf")}
                >
                  {exportLoading === "pdf"
                    ? <><span className="spinner-border spinner-border-sm me-1" />Exporting...</>
                    : <><i className="bi bi-file-earmark-pdf me-1" />PDF</>}
                </button>
                <button
                  className="btn btn-outline-success btn-sm"
                  disabled={exportLoading === "excel"}
                  onClick={() => fetchAllAndExport("excel")}
                >
                  {exportLoading === "excel"
                    ? <><span className="spinner-border spinner-border-sm me-1" />Exporting...</>
                    : <><i className="bi bi-file-earmark-excel me-1" />Excel</>}
                </button>
              </div>
            </div>

            {/* Report Filters */}
            <div className="card border-0 shadow-sm mb-3">
              <div className="card-body p-3">
                <div className="row g-2 align-items-end">
                  {isHR && (
                    <div className="col-12 col-md-3">
                      <label className="form-label small fw-semibold mb-1">Trainer</label>
                      <select
                        className="form-select form-select-sm"
                        value={reportFilters.trainer_id}
                        onChange={(e) => {
                          const tid = e.target.value;
                          setReportFilters((f) => ({ ...f, trainer_id: tid, client_id: "" }));
                          setReportPage(1);
                        }}
                      >
                        <option value="">All Trainers</option>
                        {trainers.map((t) => (
                          <option key={t.id} value={t.id}>{t.name}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Active Clients dropdown */}
                  {(() => {
                    const today = new Date().toISOString().slice(0, 10);
                    const active = Array.from(
                      new Map(
                        reportClients
                          .filter((c) => c.end_date >= today)
                          .map((c) => [c.client_id, c])
                      ).values()
                    );
                    const noTrainer = isHR && !reportFilters.trainer_id;
                    return (
                      <div className="col-12 col-md-3">
                        <label className="form-label small fw-semibold mb-1 text-success">
                          <i className="bi bi-person-check me-1" />
                          Active Client
                          {reportClientsLoading && <span className="spinner-border spinner-border-sm ms-1" />}
                        </label>
                        <select
                          className="form-select form-select-sm border-success"
                          value={reportFilters.client_id}
                          onChange={(e) => {
                            setReportFilters((f) => ({
                              ...f,
                              client_id:  e.target.value,
                              start_date: "",
                              end_date:   "",
                            }));
                            setReportPage(1);
                          }}
                          disabled={noTrainer || reportClientsLoading}
                        >
                          <option value="">
                            {noTrainer ? "Select trainer first" : active.length === 0 && !reportClientsLoading ? "No active clients" : "All Active Clients"}
                          </option>
                          {active.map((c) => (
                            <option key={c.client_id} value={c.client_id}>{c.client_name}</option>
                          ))}
                        </select>
                      </div>
                    );
                  })()}

                  {/* Old / Expired Clients dropdown */}
                  {(() => {
                    const today = new Date().toISOString().slice(0, 10);
                    const expired = Array.from(
                      new Map(
                        reportClients
                          .filter((c) => c.end_date < today)
                          .map((c) => [c.client_id, c])
                      ).values()
                    );
                    const noTrainer = isHR && !reportFilters.trainer_id;
                    return (
                      <div className="col-12 col-md-3">
                        <label className="form-label small fw-semibold mb-1 text-secondary">
                          <i className="bi bi-person-x me-1" />
                          Old Client
                        </label>
                        <select
                          className="form-select form-select-sm border-secondary"
                          value={reportFilters.client_id}
                          onChange={(e) => {
                            setReportFilters((f) => ({
                              ...f,
                              client_id:  e.target.value,
                              start_date: "",
                              end_date:   "",
                            }));
                            setReportPage(1);
                          }}
                          disabled={noTrainer || reportClientsLoading}
                        >
                          <option value="">
                            {noTrainer ? "Select trainer first" : expired.length === 0 && !reportClientsLoading ? "No old clients" : "All Old Clients"}
                          </option>
                          {expired.map((c) => (
                            <option key={c.client_id} value={c.client_id}>{c.client_name}</option>
                          ))}
                        </select>
                      </div>
                    );
                  })()}
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">From</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={reportFilters.start_date}
                      onChange={(e) => { setReportFilter("start_date", e.target.value); setReportPage(1); }}
                    />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">To</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={reportFilters.end_date}
                      onChange={(e) => { setReportFilter("end_date", e.target.value); setReportPage(1); }}
                    />
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">Trainer Status</label>
                    <select
                      className="form-select form-select-sm"
                      value={reportFilters.staff_status}
                      onChange={(e) => setReportFilter("staff_status", e.target.value)}
                    >
                      <option value="">All</option>
                      {STATUS_OPTIONS.map((s) => <option key={s}>{s}</option>)}
                    </select>
                  </div>
                  <div className="col-6 col-md-2">
                    <label className="form-label small fw-semibold mb-1">Client Status</label>
                    <select
                      className="form-select form-select-sm"
                      value={reportFilters.client_status}
                      onChange={(e) => setReportFilter("client_status", e.target.value)}
                    >
                      <option value="">All</option>
                      {STATUS_OPTIONS.map((s) => <option key={s}>{s}</option>)}
                    </select>
                  </div>
                  <div className="col-6 col-md-1">
                    <label className="form-label small fw-semibold mb-1">Per Page</label>
                    <select
                      className="form-select form-select-sm"
                      value={reportFilters.limit}
                      onChange={(e) => setReportFilter("limit", Number(e.target.value))}
                    >
                      {[10, 25, 50, 100].map((n) => <option key={n}>{n}</option>)}
                    </select>
                  </div>
                  <div className="col-12 col-md-2 d-flex gap-2">
                    <button
                      className="btn btn-primary btn-sm flex-fill"
                      onClick={() => { setReportPage(1); fetchReport(); }}
                    >
                      <i className="bi bi-search me-1" />Filter
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => {
                        setReportFilters({
                          trainer_id:    isTrainer ? UId : "",
                          client_id:     "",
                          staff_status:  "",
                          client_status: "",
                          start_date:    defaultStart,
                          end_date:      defaultEnd,
                          limit:         25,
                        });
                        if (!isTrainer) setReportClients([]);
                        setReportPage(1);
                      }}
                    >
                      <i className="bi bi-x-lg" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary stats */}
            {!reportLoading && report.length > 0 && (() => {
              const delivered = report.filter(s => s.staff_status === "Delivered" && s.client_status === "Delivered").length;
              const noShow    = report.filter(s => s.client_status === "No Show").length;
              const canceled  = report.filter(s => ["Cancel","Canceled"].includes(s.client_status)).length;
              return (
                <div className="row g-2 mb-3">
                  {[
                    { label: "Total (Page)", val: report.length,  color: "primary" },
                    { label: "Total Records", val: reportTotal,   color: "dark" },
                    { label: "Delivered",    val: delivered,      color: "success" },
                    { label: "Client No Show", val: noShow,       color: "warning" },
                    { label: "Canceled",     val: canceled,       color: "secondary" },
                  ].map((s) => (
                    <div className="col-6 col-md-2" key={s.label}>
                      <div className={`card border-0 shadow-sm text-center p-2 border-start border-${s.color} border-3`}>
                        <small className="text-muted">{s.label}</small>
                        <h5 className={`fw-bold mb-0 text-${s.color}`}>{s.val}</h5>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Report Table */}
            <div className="card border-0 shadow-sm">
              {reportLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" />
                  <p className="mt-2 text-muted">Loading report...</p>
                </div>
              ) : report.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="bi bi-bar-chart-line fa-3x mb-3 d-block" />
                  <p>No sessions found. Adjust filters and click Filter.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover align-middle small mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Date</th>
                          <th>Trainer</th>
                          <th>Client</th>
                          <th>Package</th>
                          <th>Pkg Start</th>
                          <th>Pkg End</th>
                          <th>Trainer Status</th>
                          <th>Client Status</th>
                          <th className="text-center">Validated</th>
                        </tr>
                      </thead>
                      <tbody>
                        {report.map((s, idx) => (
                          <tr key={s.id}>
                            <td className="text-muted">{(reportPage - 1) * reportFilters.limit + idx + 1}</td>
                            <td>
                              <span className="fw-semibold">{moment(s.date).format("DD MMM YYYY")}</span>
                              <br /><small className="text-muted">{s.day}</small>
                            </td>
                            <td className="fw-semibold">{s.trainer_name}</td>
                            <td>{s.client_name}</td>
                            <td className="text-muted">
                              <span className="badge bg-outline-secondary border me-1">{s.package_type}</span>
                              {s.package_name}
                            </td>
                            <td className="text-muted small">{s.package_start_date ? moment(s.package_start_date).format("DD MMM YY") : "—"}</td>
                            <td className="text-muted small">{s.package_end_date ? moment(s.package_end_date).format("DD MMM YY") : "—"}</td>
                            <td>{statusBadge(s.staff_status)}</td>
                            <td>{statusBadge(s.client_status)}</td>
                            <td className="text-center">
                              {String(s.validate_status) === "1"
                                ? <i className="bi bi-check-circle-fill text-success" />
                                : <i className="bi bi-hourglass-split text-warning" />}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="card-footer d-flex justify-content-between align-items-center">
                    <small className="text-muted">Page {reportPage} of {reportTotalPages} · {reportTotal} records</small>
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-secondary btn-sm" disabled={reportPage <= 1}
                        onClick={() => setReportPage((p) => p - 1)}>
                        <i className="bi bi-chevron-left" /> Prev
                      </button>
                      <button className="btn btn-outline-secondary btn-sm" disabled={reportPage >= reportTotalPages}
                        onClick={() => setReportPage((p) => p + 1)}>
                        Next <i className="bi bi-chevron-right" />
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}

        {/* Add Session Modal */}
        {showAddModal && (
          <SessionModal
            mode="add"
            initialData={{ branch_id: branch_id || "" }}
            trainers={trainers}
            selectedTrainer={addTrainer}
            clients={hrClients}
            onClose={() => setShowAddModal(false)}
            onSave={handleAddSession}
            saving={modalSaving}
          />
        )}

        {/* Edit Session Modal */}
        {showEditModal && selectedSession && (
          <SessionModal
            mode="edit"
            initialData={selectedSession}
            trainers={trainers}
            selectedTrainer={null}
            clients={[]}
            onClose={() => setShowEditModal(false)}
            onSave={handleEditSession}
            saving={modalSaving}
          />
        )}

        {/* Bulk Add Modal */}
        {showBulkModal && (
          <BulkModal
            trainers={trainers}
            onClose={() => setShowBulkModal(false)}
            onSave={handleBulkAdd}
            saving={modalSaving}
          />
        )}
      </div>
    </div>
  );
};

export default HRAttendancePortal;






